module.exports = __webpack_public_path__ + "static/media/vidal8.7f81d31e.png";